import type { SampleOrderDemandOption } from '../../types';

import { randBoolean, randNumber } from '@ngneat/falso';

/** Returns a mocked SampleOrderDemandOption with random sample flags. */
const mockSampleOrderDemandOption = (
    overwrite?: Partial<SampleOrderDemandOption>
): SampleOrderDemandOption => ({
    styleOptionNumber: randNumber({ min: 4000000, max: 5999999 }),
    isSalesSample: randBoolean(),
    isMeetingSample: randBoolean(),
    ...overwrite,
});

export { mockSampleOrderDemandOption };
